export const theme = {
  breakpoint: {
    mobileMax: 767,
  },
  breakpointDescription: {
    mobileS: 510,
    mobileMax: 761,
    laptopMax: 1389,
  },
  breakpointBanner: {
    mobileS: 510,
    tabletMedium: 879,
    tabletMax: 991,
    laptopMax: 1400,
    DesktopMax: 1723,
  },
  color: {
    white: "#FFFFFF",
    lightblue: "#D6E4FF",
    yellow: "#FCD420",
    lightgrey: "#F5F5FA",
    blue: "#0044CC",
    grey: "#E4E6F0",
    darkergrey: "#7E839A",
    postergrey: "#C4C4C4",
    black: "#000000",
  },
  gradient: {
    desktop: `linear-gradient(
      182deg,
      rgba(0, 0, 0, 0) 58.48%,
      rgba(0, 0, 0, 0.106473) 63.17%,
      rgba(0, 0, 0, 0.235359) 68.85%,
      rgba(0, 0, 0, 0.492821) 78.08%,
      rgba(0, 0, 0, 0.740286) 85.86%,
      #000000 92.87%
    ),
    linear-gradient(
      180deg,
      #000000 0%,
      rgba(0, 0, 0, 0.689555) 4.66%,
      rgba(0, 0, 0, 0.439033) 9.34%,
      rgba(0, 0, 0, 0.20628) 15.16%,
      rgba(0, 0, 0, 0) 24.22%
    ),
    linear-gradient(
      84deg,
      #000000 13.6%,
      rgba(0, 0, 0, 0.984059) 14.58%,
      rgba(0, 0, 0, 0.967732) 15.44%,
      rgba(0, 0, 0, 0.865569) 16.3%,
      rgba(0, 0, 0, 0.05) 22.87%,
      rgba(0, 0, 0, 0) 26.64%
    ),
    linear-gradient(
      270deg,
#000000 13.6%,
      rgba(0, 0, 0, 0.984059) 14.58%,
      rgba(0, 0, 0, 0.967732) 15.44%,
      rgba(0, 0, 0, 0.865569) 16.3%,
      rgba(0, 0, 0, 0.230315) 22.87%,
      rgba(0, 0, 0, 0) 26.64%
    )`,
    desktopMax: `linear-gradient(
      183deg,
      rgba(0, 0, 0, 0) 58.48%,
      rgba(0, 0, 0, 0.106473) 63.17%,
      rgba(0, 0, 0, 0.235359) 68.85%,
      rgba(0, 0, 0, 0.492821) 78.08%,
      rgba(0, 0, 0, 0.740286) 85.86%,
      #000000 92.87%
    ),
    linear-gradient(
      180deg,
      #000000 0%,
      rgba(0, 0, 0, 0.689555) 4.66%,
      rgba(0, 0, 0, 0.439033) 9.34%,
      rgba(0, 0, 0, 0.20628) 15.16%,
      rgba(0, 0, 0, 0) 24.22%
    ),
    linear-gradient(
      84deg,
      #000000 8.6%,
      rgba(0, 0, 0, 0.984059) 9.58%,
      rgba(0, 0, 0, 0.967732) 10.44%,
      rgba(0, 0, 0, 0.865569) 11.3%,
      rgba(0, 0, 0, 0.05) 17.87%,
      rgba(0, 0, 0, 0) 21.64%
    ),
    linear-gradient(
      270deg,
      #000000 8.6%,
      rgba(0, 0, 0, 0.984059) 9.58%,
      rgba(0, 0, 0, 0.967732) 10.44%,
      rgba(0, 0, 0, 0.865569) 11.3%,
      rgba(0, 0, 0, 0.230315) 17.87%,
      rgba(0, 0, 0, 0) 21.64%
    )`,
    laptopMax: `
    linear-gradient(
          183deg,
          rgba(0, 0, 0, 0) 58.48%,
          rgba(0, 0, 0, 0.106473) 63.17%,
          rgba(0, 0, 0, 0.235359) 68.85%,
          rgba(0, 0, 0, 0.492821) 78.08%,
          rgba(0, 0, 0, 0.740286) 85.86%,
          #000000 92.87%
        ),
        linear-gradient(
          180deg,
          #000000 0%,
          rgba(0, 0, 0, 0.689555) 4.66%,
          rgba(0, 0, 0, 0.439033) 9.34%,
          rgba(0, 0, 0, 0.20628) 15.16%,
          rgba(0, 0, 0, 0) 24.22%
        ),
        linear-gradient(
          84deg,
          #000000 4.6%,
          rgba(0, 0, 0, 0.984059) 5.58%,
          rgba(0, 0, 0, 0.967732) 6.44%,
          rgba(0, 0, 0, 0.865569) 7.3%,
          rgba(0, 0, 0, 0.05) 13.87%,
          rgba(0, 0, 0, 0) 17.64%
        ),
        linear-gradient(
          270deg,
          #000000 4.6%,
          rgba(0, 0, 0, 0.984059) 5.58%,
          rgba(0, 0, 0, 0.967732) 6.44%,
          rgba(0, 0, 0, 0.865569) 7.3%,
          rgba(0, 0, 0, 0.230315) 13.87%,
          rgba(0, 0, 0, 0) 17.64%
        )`,
    mobileS: `
        linear-gradient(
          182.44deg,
          rgba(0, 0, 0, 0) 58.48%,
          rgba(0, 0, 0, 0.106473) 63.17%,
          rgba(0, 0, 0, 0.235359) 68.85%,
          rgba(0, 0, 0, 0.492821) 78.08%,
          rgba(0, 0, 0, 0.740286) 85.86%,
          #000000 92.87%
        ),
        linear-gradient(
          180deg,
          #000000 0%,
          rgba(0, 0, 0, 0.689555) 4.66%,
          rgba(0, 0, 0, 0.439033) 9.34%,
          rgba(0, 0, 0, 0.20628) 15.16%,
          rgba(0, 0, 0, 0) 24.22%
        ),
        linear-gradient(
          84deg,
          #000000 7.6%,
          rgba(0, 0, 0, 0.984059) 8.58%,
          rgba(0, 0, 0, 0.967732) 9.44%,
          rgba(0, 0, 0, 0.865569) 10.3%,
          rgba(0, 0, 0, 0.05) 16.87%,
          rgba(0, 0, 0, 0) 20.64%
        ),
        linear-gradient(
          270deg,
          #000000 7.6%,
          rgba(0, 0, 0, 0.984059) 8.58%,
          rgba(0, 0, 0, 0.967732) 9.44%,
          rgba(0, 0, 0, 0.865569) 10.3%,
          rgba(0, 0, 0, 0.14) 16.87%,
          rgba(0, 0, 0, 0) 20.64%
        )`,
  },
  shadow: {
    elevation: "0px 4px 12px 0px #BAC7D580",
    soft: "0px 4px 12px 0px #C4C4C4",
  },
};
